import './404.scss';
import gif404 from '../../assets/images/404.gif';

const error404 = () => {

  return (
    <main className="error">
      <h1 className="error-title">Whoops, vous êtes visiblement perdu 🤔</h1>
      <p className="error-content">Voici un petit lien pour <a href="/">retourner à l'accueil</a></p>
      <img className="error-img" src={gif404} alt="" />
    </main>
  );
};

export default error404;
